import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./appScreens/Layout";
import Home from "./appScreens/Home";
import Summary from "./appScreens/Summary";
import Late from "./appScreens/Late";
import More from "./appScreens/More";
import MoreProfile from "./appScreens/MoreProfile";
import MoreBirthdays from "./appScreens/MoreBirthdays";
import MoreGathering from "./appScreens/MoreGathering";
import MoreContributions from "./appScreens/MoreContributions";
import MoreHistory from "./appScreens/MoreHistory";
import Contacts from "./appScreens/Contacts";
import Login from "./appScreens/Login";
import NoPage from "./appScreens/NoPage";
import "./App.css";
import SignIn from "./appScreens/SignIn";
import SignUp from "./appScreens/SignUp";
import AdminLayout from "./appScreens/AdminLayout";
import AdminHome from "./appScreens/AdminHome";
import AdminLate from "./appScreens/AdminLate";
import AdminContacts from "./appScreens/AdminContacts";
import AdminMore from "./appScreens/AdminMore";
import AdminNoPage from "./appScreens/AdminNoPage";
import AdminSick from "./appScreens/AdminSick";
import MemberBirthday from "./appScreens/MemberBirthday";
import MemberGathering from "./appScreens/MemberGathering";
import MemberContributions from "./appScreens/MemberContributions";
import MemberHistory from "./appScreens/MemberHistory";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Login />}>
          <Route index element={<Login />} />
        </Route>
        <Route path="/signin" element={<SignIn />}>
          <Route index element={<SignIn />} />
        </Route>
        <Route path="/signup" element={<SignUp />}>
          <Route index element={<SignUp />} />
        </Route>
        <Route path="/app" element={<Layout />}>
          <Route index element={<Layout />} />
          <Route path="home" element={<Home />} />
          <Route path="summary" element={<Summary />} />
          <Route path="late" element={<Late />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="more" element={<More />} />
          <Route path="birthdays" element={<MemberBirthday />} />
          <Route path="gatherings" element={<MemberGathering />} />
          <Route path="contributions" element={<MemberContributions />} />
          <Route path="history" element={<MemberHistory />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminHome />} />
          <Route path="home" element={<AdminHome />} />
          <Route path="Sick" element={<AdminSick />} />
          <Route path="late" element={<AdminLate />} />
          <Route path="contacts" element={<AdminContacts />} />
          <Route path="more" element={<AdminMore />} />
          <Route path="profile" element={<MoreProfile />} />
          <Route path="birthdays" element={<MoreBirthdays />} />
          <Route path="gatherings" element={<MoreGathering />} />
          <Route path="contributions" element={<MoreContributions />} />
          <Route path="history" element={<MoreHistory />} />
          <Route path="*" element={<AdminNoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
